import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Linechart from "../../components/ReportComponents/LineChart";
import Dailychart from "../../components/ReportComponents/DailyChart";
import Hourlychart from "../../components/ReportComponents/HourlyChart";
import CampaignTable from "../../components/ReportComponents/CampaignTable";
import PublishersTable from "../../components/ReportComponents/PublishersTable";

import { getTopBoard } from "../../redux/slices/reportSlice";

import { Container, TableWrapper } from "./ReportStyles";
import {
  PageHeader,
  PageStack,
  Panel,
  SectionHeader,
  SegmentedTabs,
  StatCard,
  StatGrid,
} from "../../components/common/ui";
import theme from "../../theme";

const GRANULARITY = [
  { value: "month", label: "By month" },
  { value: "day", label: "By day" },
  { value: "hour", label: "By hour" },
];

const Report = () => {
  const dispatch = useDispatch();
  const { topBoard } = useSelector((state) => state.report);

  const [granularity, setGranularity] = useState("month");

  useEffect(() => {
    dispatch(getTopBoard());
  }, [dispatch]);

  return (
    <Container>
      <PageStack>
        <PageHeader>
          <div>
            <h1>Report and analytics</h1>
            <p>Conversion performance across campaigns and publishers.</p>
          </div>
        </PageHeader>

        <StatGrid>
          <StatCard
            label="Total campaigns"
            value={topBoard.totalCampaigns}
            hint="Across all advertisers"
            accent={theme.color.brand}
            glyph="◎"
          />
          <StatCard
            label="Total advertisers"
            value={topBoard.totalAdvertisers}
            hint="Registered on ClickCircle"
            accent={theme.chart[2]}
            glyph="◇"
          />
          <StatCard
            label="Total publishers"
            value={topBoard.totalPublishers}
            hint="Distributing your ads"
            accent={theme.chart[1]}
            glyph="⬡"
          />
        </StatGrid>

        <Panel>
          <SectionHeader
            title="Performance analytics"
            subtitle="Conversions over time"
          >
            <SegmentedTabs
              options={GRANULARITY}
              value={granularity}
              onChange={setGranularity}
            />
          </SectionHeader>

          {granularity === "month" && <Linechart />}
          {granularity === "day" && <Dailychart />}
          {granularity === "hour" && <Hourlychart />}
        </Panel>

        <Panel $flush>
          <TableWrapper>
            <SectionHeader
              title="Campaigns"
              subtitle="Reach, conversions and spend per campaign"
              inset
              divided
            />
            <CampaignTable />
          </TableWrapper>
        </Panel>

        <Panel $flush>
          <TableWrapper>
            <SectionHeader
              title="Publishers"
              subtitle="Traffic and earnings per publisher"
              inset
              divided
            />
            <PublishersTable />
          </TableWrapper>
        </Panel>
      </PageStack>
    </Container>
  );
};

export default Report;
